import { Box, Button, Heading, FormControl, Skeleton, Text } from "@chakra-ui/react";

const LeadFormSkeleton = () => {
  return (
    <Box
      bg="white"
      borderRadius="8px"
      minW={{
        base: "0px",
        md: "450px",
      }}
      boxShadow="0px 0px 20px 0px rgba(14, 41, 50, 0.17)"
      p={{
        base: "20px",
        md: "45px",
      }}
      zIndex="1"
    >
      <Heading
        as="h4"
        fontSize="26px"
        fontWeight="700"
        letterSpacing="-0.52px"
        mb="34px"
        textAlign="center"
        color="brand.secondary"
      >
        See if you pre-qualify!
      </Heading>
      <FormControl mb="20px">
        <Skeleton height="48px" borderRadius="md" />
      </FormControl>
      <FormControl mb="20px">
        <Skeleton height="48px" borderRadius="md" />
      </FormControl>
      <FormControl mb="20px">
        <Skeleton height="48px" borderRadius="md" />
      </FormControl>
      <FormControl mb="20px">
        <Skeleton height="48px" borderRadius="md" />
      </FormControl>
      <Button
        borderRadius="8px"
        bg="brand.secondary"
        py="15px"
        px="28px"
        fontSize="18px"
        lineHeight="24px"
        fontWeight="700"
        color="white"
        w="100%"
        h="54px"
        isDisabled
        _hover={{
          bg: "#2D2D3E",
          textDecoration: "none",
        }}
      >
        Check Eligibility
      </Button>
      <Text mt="12px" textAlign="center" fontSize="14px" color="transparent">
        You agree to our Terms & Conditions and Privacy Policy when submitting your information.
      </Text>
    </Box>
  );
};

export default LeadFormSkeleton;
